import type { ViewQueryRecordNodeWithId } from '@salescore/core'
import { Array, HashMap, Option, pipe } from 'effect'
import { useCallback } from 'react'
import { useRecoilValue } from 'recoil'

import { useRecordsImpl } from '../../../recoil/records'
import { rowConfigsImplAtom } from '../../../recoil/rowConfig'
import { clampRowInnerRowSpan } from '../../util/clampRowInnerRowSpan'

export const useGetRowHeight = (visibleRowNumber: number | undefined) => {
  const rows = useRecordsImpl()
  const rowConfigMap = useRecoilValue(rowConfigsImplAtom)

  const getRowHeight = useCallback(
    (row: ViewQueryRecordNodeWithId) => {
      const expanded = pipe(
        rowConfigMap,
        HashMap.get(row.id),
        Option.exists((config) => config.expanded),
      )
      return clampRowInnerRowSpan({ record: row, visibleRowNumber, expanded })
    },
    [rowConfigMap, visibleRowNumber],
  )
  return {
    getRowHeight,
    getRowHeightWithRowIndex: useCallback(
      (rowIndex: number) =>
        pipe(
          rows,
          Array.get(rowIndex),
          Option.map(getRowHeight),
          Option.getOrElse(() => 0),
        ),
      [getRowHeight, rows],
    ),
  }
}
